import React, { Component } from "react";
import { Box, chakra } from "@chakra-ui/react";
import FullScreen from "src/atoms/FullScreen";
import RoundButton from "src/components/RoundButton";
import { ReactComponent as CloseIcon } from "./close.svg";

const EnhancedVideo = chakra("video");

export default class SeeMeMode extends Component {
  videoRef = React.createRef();

  componentDidMount = () => {
    const { remoteVideoStream } = this.props;
    if (this.videoRef.current)
      this.videoRef.current.srcObject = remoteVideoStream;
  };

  componentDidUpdate(prevProps, prevState) {
    const { remoteVideoStream } = this.props;
    if (
      this.videoRef.current &&
      this.videoRef.current.srcObject !== remoteVideoStream
    )
      this.videoRef.current.srcObject = remoteVideoStream;
  }

  render() {
    const { onClose, frame } = this.props;
    return (
      <FullScreen ignoreFrame position="absolute">
        <EnhancedVideo
          ref={this.videoRef}
          width="100%"
          height="100%"
          bg="black"
          objectFit="cover"
          autoPlay
          muted
        />
        <Box
          position="absolute"
          top={`${16 + (frame ? frame.height : 0)}px`}
          left="16px"
        >
          <RoundButton
            onClick={onClose}
            bg="black20"
            size="32px"
            icon={CloseIcon}
            iconFill="white"
            iconSize="20px"
          />
        </Box>
      </FullScreen>
    );
  }
}
